import {
  CompensationMethodData,
  ENSO_RING_ENGRAVING_FEE,
  ENSORINGS_ENGRAVING_ID_FREE,
  ENSORINGS_ENGRAVING_ID_PAID,
} from "@redotech/redo-customer-portal-shared/flow/util";
import { ExchangeVariant } from "@redotech/redo-model/draft-return/draft-return-items";
import { ReturnTypeEnum } from "@redotech/redo-model/return";
import {
  Button,
  ButtonBorder,
  ButtonSize,
  ButtonTheme,
} from "@redotech/redo-web/button";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import * as questions from "../choose-items.module.css";
import * as multipleChoice from "./multiple-choice-question.module.css";
import * as variantExchange from "./variant-exchange.module.css";

export const EnsoEngravingFee = memo(function EnsoEngravingFee({
  multipleChoiceAnswers,
  returnType,
  submitItem,
  selectedVariant,
}: {
  multipleChoiceAnswers: string[];
  returnType?: ReturnTypeEnum;
  submitItem: (data: CompensationMethodData) => void;
  selectedVariant: ExchangeVariant | null;
}) {
  const isFree =
    ["Received wrong item", "Lost in transit", "Missing item"].some((reason) =>
      multipleChoiceAnswers.includes(reason),
    ) || returnType === "claim";

  const headerText = isFree
    ? "Would you like to keep the same engraving?"
    : `Would you like to keep the same engraving for an additional $${ENSO_RING_ENGRAVING_FEE}?`;

  return (
    <Flex dir="column" grow={1}>
      <div className={variantExchange.cardContent}>
        <div className={variantExchange.topContent}>
          <div>
            <h2 className={variantExchange.variantScreenTitle}>{headerText}</h2>
          </div>
        </div>
        <div className={multipleChoice.grid}>
          <Button
            border={ButtonBorder.LIGHT}
            onClick={() => {
              if (selectedVariant) {
                submitItem({
                  advancedExchangeItems: [
                    {
                      variantId: isFree
                        ? ENSORINGS_ENGRAVING_ID_FREE
                        : ENSORINGS_ENGRAVING_ID_PAID,
                      productId: String(selectedVariant.productId),
                      quantity: 1,
                      properties: {},
                    },
                  ],
                  variantExchangeItem: {
                    variantId: selectedVariant.id,
                    preserveProperties: true,
                    image: selectedVariant.image,
                    title: selectedVariant.title,
                  },
                });
              }
            }}
            pending={false}
            size={ButtonSize.MEDIUM}
            theme={ButtonTheme.SOLID_LIGHT}
          >
            <div className={questions.optionButton}>
              <div className={questions.optionText}>Yes</div>
            </div>
          </Button>
          <Button
            border={ButtonBorder.LIGHT}
            disabled={false}
            onClick={() => {
              if (selectedVariant) {
                submitItem({
                  variantExchangeItem: {
                    variantId: selectedVariant.id,
                    preserveProperties: true,
                    image: selectedVariant.image,
                    title: selectedVariant.title,
                  },
                });
              }
            }}
            size={ButtonSize.MEDIUM}
            theme={ButtonTheme.SOLID_LIGHT}
          >
            <div className={questions.optionButton}>
              <div className={questions.optionText}>No</div>
            </div>
          </Button>
        </div>
      </div>
    </Flex>
  );
});
